import React from "react";
import { ModoTemaContext } from "./modoTema";
import { Paleta, paletaDoModo } from "./paletaCores";

export const usePaletaAtiva = (): Paleta => paletaDoModo(React.useContext(ModoTemaContext).modo);
